export default __webpack_public_path__ + "static/media/deactivate.4e28fcb5.svg";